import {
  CARD_DETAIL_COLOR,
  COMMON_MESSAGES,
  COMMON_ERRORS,
  SHARED_PERMISOS_TYPES,
  allItemsFilter,
  SHARED_PERMISOS,
  tdSchedulerUserHeaders,
  TRANSLATION_ERRORS,
} from '@utils/constants';
import {
  getKeysExcept,
  toUpperCaseMonth,
} from '@licencias/TableLicenses/helperTable';
import { formatDate, formatDateToReadableMonth } from '@utils/date';
import theme from '@theme';
import { DATE_FORMAT } from 'react-big-scheduler-stch';
import parsePhoneNumber from 'libphonenumber-js';
import { LICENCIAS_GANTT } from '@licencias/utils/constants';
import { isTypeOthers } from '@licencias/utils/functions';

export const getURLKeys = (keyParams) => {
  if (keyParams && keyParams !== '') return keyParams.split(',');
  return [];
};

function removeEmptyProperties(objeto) {
  const nuevoObjeto = {};
  for (const clave in objeto) {
    if (objeto[clave] !== '') {
      nuevoObjeto[clave] = objeto[clave];
    }
  }
  return nuevoObjeto;
}

export const getUrlFilters = (params) => {
  const searchParams = new URLSearchParams();
  const entries = Object.entries(removeEmptyProperties(params));
  entries.forEach(([key, value]) => searchParams?.append(key, value));
  const queryString = decodeURIComponent(searchParams?.toString());
  return queryString ? '?' + queryString : '';
};

export const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && String(item).trim() !== '') {
          searchParams.append(key, String(item).trim());
        }
      });
      return;
    }

    if (typeof value === 'string') {
      if (value.trim() !== '') {
        searchParams.append(key, value.trim());
      }
      return;
    }

    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const formatFullname = (option) => {
  if (option?.first_name && option?.last_name) {
    return option?.first_name + ' ' + option?.last_name;
  }
  return '';
};

export const buildFullUsername = (data) =>
  `${data?.first_name} ${data?.last_name}`;

export const buildFullUsername2 = (data) =>
  `${data?.last_name}, ${data?.first_name}`;

export const getInitials = (firstName, lastName) => {
  return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`;
};

export const getDaysForType = (licensesDetails) => {
  const days = licensesDetails?.days;
  const type = licensesDetails?.type;

  return days && type
    ? {
        ceres: days[type]?.ceres,
        in_process: days[type]?.in_process,
        available: days[type]?.available,
        requested: days[type]?.requested,
        remaining: days[type]?.remaining,
        returned: days[type]?.returned,
        toBeDiscount: days[type]?.a_descontar_sueldo,
      }
    : {};
};

export const onKeyDownEscape = (event, setOpen) => {
  if (event.key === 'Escape') {
    setOpen(false);
  }
};

export const createTextLinks = (text) => {
  return (text.toString() || '').replaceAll(
    /([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi,
    function (match, space, url) {
      let hyperlink = url;
      if (!hyperlink.match('^https?://')) {
        hyperlink = 'http://' + hyperlink;
      }
      return (
        space +
        '<a href="' +
        hyperlink +
        '" target="_blank" rel="noreferrer">' +
        url +
        '</a>'
      );
    },
  );
};

export const getIdFromUrl = (friendlyUrl) => {
  return friendlyUrl?.split('-')?.[0];
};

export const replaceUrlFromProd = (url) => {
  if (isProdHost() && isUrlProd(url))
    return url.replace('https://portal.arsat.com.ar', '');
  return url;
};

export const buildTargetLink = (url) => {
  return isRelativeUrl(url) || (isProdHost() && isUrlProd(url)) ? '_self' : url;
};

export const isRelativeUrl = (url) => {
  return !(url.indexOf('://') > 0 || url.indexOf('//') === 0);
};

export const isProdHost = () => {
  return (
    globalThis.window.location.host === process.env.NEXT_PUBLIC_PORTAL_HOST
  );
};

export const isUrlProd = (url) => {
  return url?.includes(process.env.NEXT_PUBLIC_PORTAL_HOST) || false;
};

export const getMultiErrors = (array) => {
  return array?.length > 0 ? (
    <>
      {array?.map((item) => (
        <div key={item}>{COMMON_ERRORS[item] || item} </div>
      ))}
    </>
  ) : (
    COMMON_MESSAGES.error
  );
};

export const formatDayCard = (date) => {
  const readableDate = toUpperCaseMonth(formatDateToReadableMonth(date));

  if (readableDate) {
    const [day, month, year] = readableDate.split(' ');
    const abbreviatedMonth = month.length > 3 ? month.slice(0, 3) : month;
    const formattedDate = `${day} ${abbreviatedMonth} ${year}`;
    return formattedDate;
  }
};

export const scrollToElementById = (idElement) => {
  const elementToScroll = document.getElementById(idElement);
  if (!elementToScroll) return false;
  elementToScroll.scrollIntoView({ behavior: 'smooth' });
};

export const isTouchDevice = () => {
  return (
    !!globalThis.window &&
    ('ontouchstart' in globalThis.window ||
      globalThis.navigator.maxTouchPoints > 0)
  );
};
export const formatSchedulerData = (arrayEvents) => {
  arrayEvents.forEach((event) => {
    const type = event?.title;
    event.bgColor =
      (event.manual && !isTypeOthers(type)) ||
      (isTypeOthers(type) && event?.ausente)
        ? LICENCIAS_GANTT?.manual?.color
        : LICENCIAS_GANTT?.[type]?.color?.[event?.status_process] ||
          CARD_DETAIL_COLOR?.interrupted;
    event.startResizable = false;
    event.endResizable = false;
    event.start = formatDate(event?.start, DATE_FORMAT.SCHEDULER);
    event.end = formatDate(event.end, DATE_FORMAT.SCHEDULER);
  });
  return arrayEvents;
};

export const formatResourcesSchedulerData = (arrayResources) => {
  arrayResources.forEach((resource, index) => {
    resource.name = `${resource?.last_name}, ${resource?.first_name}`;
    resource.index = index;
  });
  return arrayResources;
};

export const isAllSelected = (array, options) => {
  return (
    array?.sort((a, b) => a.localeCompare(b)).toString() ===
    getKeysExcept(options, allItemsFilter.value)
      ?.sort((a, b) => a.localeCompare(b))
      .toString()
  );
};

export const getValidsSlotIds = (arrayIdUrl, arrayIdData) => {
  const idsData = arrayIdData.map((objeto) => objeto.id);

  const sameElements = idsData.filter((elemento) =>
    arrayIdUrl.includes(elemento),
  );

  return sameElements;
};

export const isViewBalance = (balance) => {
  return balance ? '' : 'true';
};

export const normalizedString = (string) => {
  if (!string) return string;

  return string
    .split('')
    .map((char) => {
      if (char === 'Ñ' || char === 'ñ') return char;
      return char.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, '');
    })
    .join('')
    .toLowerCase();
};

export const normalizedStringWithAccents = (string) => {
  if (!string) return string;
  return string.normalize('NFC').toLowerCase();
};

export const removeMultipleSlotIdFilter = (arrayIds, actualSlotIds) => {
  return actualSlotIds?.filter((item) => !arrayIds?.includes(item));
};

export const searchRelatedIds = (idBuscado, resources) => {
  let foundIds = [];

  resources?.forEach((objeto) => {
    if (objeto.parentId === idBuscado) {
      foundIds.push(objeto.id || objeto.slotId);
      foundIds = foundIds.concat(
        searchRelatedIds(objeto.id || objeto.slotId, resources),
      );
    }
  });

  return foundIds;
};

export const filterSelectedItems = (selectedArray, optionsArray) => {
  if (selectedArray?.length > 0)
    return optionsArray.filter((item) => !selectedArray.includes(item));
  else return optionsArray;
};

export const convertArrayToObject = (arrayOriginal) => {
  const object = {};

  arrayOriginal?.forEach((valor) => {
    object[valor] = valor;
  });

  return object;
};

export const getUserSharedById = ({ userData, idUserCompartido }) => {
  const userShared =
    userData?.compartido_conmigo?.length > 0
      ? userData?.compartido_conmigo.find(
          (user) => user.id_user == idUserCompartido,
        )
      : null;
  return userShared;
};

export const canViewShared = ({ userShared }) => {
  if (!userShared) return false;
  return SHARED_PERMISOS_TYPES.includes(userShared?.permiso);
};

export const isEditorUserShared = ({ userShared }) => {
  if (!userShared) return false;
  return SHARED_PERMISOS.EDITOR === userShared?.permiso;
};

export const formatPhoneNumber = (numero) => {
  return numero && parsePhoneNumber(numero, 'AR')?.formatNational();
};

export const imageBase64 = (image, callback) => {
  const reader = new FileReader();
  reader.onload = () => {
    const base64Data = reader.result;
    callback(base64Data);
  };
  reader.readAsDataURL(image);
};

export const getFormData = (fileData, alt) => {
  let fd = new FormData();
  fd.append('file', fileData);
  fd.append('alt', alt);
  return fd;
};

export const setIdTdUserHeaders = (resources) => {
  const tdElements = document.querySelectorAll('.scheduler-content-table td');

  const hastd = tdElements?.length > 0;
  const hasResources = resources?.length > 0;

  if (hastd && hasResources)
    resources.forEach((element, index) => {
      tdElements[index]?.setAttribute(
        'id',
        index < 2 ? tdSchedulerUserHeaders : '',
      );
    });
};

export const isPhoneValidToShow = ({ tipo, numero, interno }) => {
  if (!numero) return false;
  return !(tipo === 'fijo_benavidez' && !interno);
};

export const hasMultiplePhoneNumbers = (telefonos) => {
  let validNumberCounter = 0;
  telefonos?.forEach(({ numero }) => {
    if (numero.length > 0) {
      validNumberCounter++;
    }
  });
  return validNumberCounter != 1;
};

export const getLocationUser = (workPlace) => {
  const { lugar_trabajo, detalle, piso } = workPlace || {};
  let location = '';
  if (lugar_trabajo) location += lugar_trabajo;
  if (detalle) location += ` - ${detalle}`;
  if (piso) location += ` - ${piso}`;
  return location;
};

export const isLocalhost = () => {
  return process.env.NODE_ENV === 'development';
};

export const diffHoursDates = (dateStart, dateEnd) => {
  const diferenciaMilisegundos = dateEnd.diff(dateStart);
  const diferenciaHoras = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60));
  const diferenciaMinutos = Math.floor(
    (diferenciaMilisegundos % (1000 * 60 * 60)) / (1000 * 60),
  );
  const horasFormateadas = String(diferenciaHoras || 0).padStart(2, '0');
  const minutosFormateados = String(diferenciaMinutos || 0).padStart(2, '0');

  return `${horasFormateadas}:${minutosFormateados}`;
};

export const readMinutesAsTime = (minutos) => {
  if (minutos === 0) return '0:00';
  let horas = Math.floor(minutos / 60);
  let minutosSobrantes = Math.floor(minutos - horas * 60);
  if (horas && minutosSobrantes) return `${horas}:${minutosSobrantes}`;
  if (horas) return `${horas}:00`;
  return `0:${minutosSobrantes}`;
};

export const minutesToHours = (minutes) => {
  const hours = Math.floor(minutes / 60);
  return hours;
};

export const minutesToHoursText = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;

  const hoursModified = hours >= 10 ? hours : `0${hours}`;
  const minutesModified = minutesLeft >= 10 ? minutesLeft : `0${minutesLeft}`;
  return `${hoursModified}:${minutesModified}`;
};

export const minutesToHoursWithDecimal = (minutes) => {
  const hours = Math.trunc(minutes / 60);
  let min = minutes % 60;
  if (min < 10) {
    min = '0' + min;
  }
  return hours + ':' + min;
};

export const getPercentage = (num, total) => {
  return Math.floor((num / total) * 100);
};

export const removeSpecialCharacters = (value) => {
  return value?.replaceAll(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ@.\s]/g, '');
};

export const existeID = (arr, id) => {
  if (Array.isArray(arr)) {
    const ids = arr.map((e) => e.id);
    return ids.includes(id);
  }
  return false;
};

export const getAlertWaf = async (supportID) => {
  if (!document.getElementById('modalOverlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'modalOverlay';
    overlay.classList.add('modal-overlay-waf');

    const modal = document.createElement('div');
    modal.id = 'AlertaBloqueoWaf';
    modal.classList.add('modal-content-waf');

    modal.innerHTML = `
      <p class="modal-title-waf" > BLOQUEO DE CIBERSEGURIDAD</p>
      <p>Debes solicitar su resolución por un correo a soporte@arsat.com.ar con el asunto: "BLOQUEO WAF ID: ${supportID}".</p>
      <p>Te facilitamos un correo con la plantilla prearmada.</p>    
  
      <div class="modal-footer-waf">
        <a class="buttonEnviarMailWaff" href="mailto:soporte@arsat.com.ar?subject=BLOQUEO%20WAF%20ID:%20 ${supportID}&body=Estimados,%0A%0AUtilizando%20el%20portal%20de%20empleados%20me%20apareció%20un%20bloqueo%20del%20WAF%20ID:%20${supportID}%0A%0AAguardo%20su%20resolución.%0AAtentamente.">Enviar correo</a>
        <button class="buttonCancelarMailWaff" id="cerrarAlerta">Cancelar</button>
      </div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.querySelectorAll('#cerrarAlerta').forEach((btn) => {
      btn.onclick = () => overlay.remove();
    });
  }
};

export const resolveThemeColor = (colorKey) => {
  if (!colorKey || typeof colorKey !== 'string') return colorKey;

  const keys = colorKey.split('.');
  let resolved = theme.palette;

  for (const key of keys) {
    if (resolved?.[key] === undefined) return colorKey;
    resolved = resolved[key];
  }

  return resolved;
};

export const getErrorText = (error) => {
  if (!navigator?.onLine) return TRANSLATION_ERRORS?.offline;
  return (
    TRANSLATION_ERRORS?.[error] ||
    TRANSLATION_ERRORS?.[error?.message] ||
    error?.message ||
    error
  );
};

export const buildBodyRequestForm = (files) => {
  let fd = new FormData();
  if (files) {
    for (const file of files) {
      fd.append('file_list', file);
    }
  }

  return fd;
};

export const normalizePath = (path = '') =>
  path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
